// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2YrCD","selected":"Chip_selected__2gt4W"};